export const UPDATE_CONFIG = "UPDATE_CONFIG";
export const UPDATE_CASHPICKUP = "UPDATE_CASHPICKUP";
export const UPDATE_SOURCE_OF_INCOME = "UPDATE_SOURCE_OF_INCOME";
export const UPDATE_TELCOS = "UPDATE_TELCOS";
export const UPDATE_PURPOSE_OF_TRANSFER = "UPDATE_PURPOSE_OF_TRANSFER";